module.exports = __webpack_public_path__ + "static/img/car_none.322f0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car_none.png
// module id = b/Mg
// module chunks = 1